<div class="d-flex flex-column align-items-start">
  @if(crmService.wizardLoading().isLoadingWizardStep){
  <zint-loader class="mx-auto" size="small"></zint-loader>
  }
  <span class="d-block full-width" [matTooltip]="!requiredCheckboxChecked ? 'Please accept our Ts&Cs first': null">
    @if (allowReauthorisation){Your account is already connected, but you may re-authorise below.}
    <button class="rounded-btn-base rounded-btn-dark-outline btn-p-lg full-width" [disabled]="!requiredCheckboxChecked || isAuthorisingDynamics" (click)="authAction()">
      <img alt="logo" class="crm-logo" src="https://www.google.com/s2/favicons?sz=64&domain={{crmType}}.com" width="24">
        @if (!allowReauthorisation){ Sign in with} @else{ Re-Authorise} {{crmType | titlecase}}
        <zint-loader *ngIf="crmService.wizardLoading().isLoadingWizardStepAction" size="xxSmall" isInline="true"></zint-loader>
        <i class="far fa-circle-check fa-fade ml-2" style="color: var(--zint-light-green);" *ngIf="crmService.wizardStepsReadyState()['auth']"></i>
    </button>
  </span>
  <label for="testCheckbox" class="my-3">
    <input type="checkbox" id="testCheckbox" [(ngModel)]="requiredCheckboxChecked" (ngModelChange)="getStepActionContent()"
    [disabled]="isTnCCheckboxDisabled() || isAuthorisingDynamics" />
    <span class="ml-1">By authorising this integration you agree to the <a class="text-link" role="button" (click)="openTermsModal()">Terms and Conditions</a>. 
    </span>
  </label>   

  @if (crmType === 'dynamics') {
    <div class="dynamics-environment full-width my-2" aria-live="polite">
      @if (dynamicsEnvironmentHost) {
        <strong>Connected environment</strong>
        @if (dynamicsEnvironmentName) { <span class="d-block">{{ dynamicsEnvironmentName }}</span> }
        <span class="d-block text-grey-600">{{ dynamicsEnvironmentHost }}</span>
      }
      @if (isAuthorisingDynamics) {
        <p class="mb-1">Finish signing in and choosing your Dynamics environment in the new tab.</p>
        <button class="rounded-btn-base rounded-btn-white btn-p-sm my-2" (click)="retryDynamicsAuthorisation()" [disabled]="crmService.wizardLoading().isLoadingWizardStepAction">Try signing in again</button>
      } @else {
        <p class="mb-1">Sign in to choose or change your Dynamics environment.</p>
      }
      <small class="text-grey-600">This environment applies to your Zint user account across all Dynamics objects and teams you access.</small>
      @if (dynamicsAuthorisationMessage) {
        <p class="mt-2 mb-0" role="status">{{ dynamicsAuthorisationMessage }}</p>
      }
    </div>
  }
  
  <button class="rounded-btn-base rounded-btn-white text-grey-600 btn-p-sm small align-self-end" (click)="openDataUseModal()"><i class="fa-kit fa-light-shield-halved-circle-question mr-1"></i>What does ZINT do with my data?</button>

</div>

@if (showDataUsageModal) {
  <zint-modal [modalConfig]="dataUsageModalConfig">
    <iframe modalContent class="w-100 min-height-75vh" title="What Zint Do With My Data"
      src="https://docs.google.com/document/d/e/2PACX-1vTIjPVJLT1ZJMk92hRIEfRvxklosk19NgLA6x6ubqIuwqE0k1bG0M8VMpa9cQ_y6flkpnzIkZTy0i0x/pub">
    </iframe>
  </zint-modal>
}

@if (showTermsModal) {
  <zint-modal [modalConfig]="termsModalConfig">
    <iframe modalContent class="w-100 min-height-75vh" title="Ts&Cs"
      src="https://docs.google.com/document/d/e/2PACX-1vRBgu4nHV4ugr_6c5fLu6-0CWunW8lNnNFPVfZjYeMPmW4QZcqkJUqCjr4ExZ9eiKdQChf2trNPb3Mp/pub">
    </iframe>
  </zint-modal>
}
